import { Button, Menu, MenuItem, Stack, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { useState } from "react";
import { capitalizeWords } from "../../utils/common";
import wishlistAddIcon from '../../assets/images/icons/User_Add_Wishlist.svg'
import Xred from '../../assets/images/icons/Xred.svg'
import plusIcon from '../../assets/images/icons/plusIcon.svg'
import { updateWishlist } from '../../pages/company-wishlist/wishlistSlice';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    top: 'revert',
    bottom: '20px',
    left: '50%',
    border: '0px solid red',
    borderRadius: '16px', padding: '0px',
    backgroundRepeat: 'no-repeat',
    height: 'fit-content', width: 'fit-content',
    transform: 'translateX(-50%)',
    "& .MuiDialog-container": {
        margin: 0,
    },
    "& .MuiPaper-root": {
        margin: '0px !important',
        background: "linear-gradient(119deg,rgba(200, 80, 192, 1) 42%, rgba(65, 88, 208, 1) 100%)",
        border: '0px solid blue',
        backgroundColor: 'transparent',
        borderRadius: '16px',
        maxWidth: '1000px',
        [theme.breakpoints.down('sm')]: {
            width: '420px',
            height: '90px',
            padding: '5px 10px'
        },
        [theme.breakpoints.between('sm', 'md')]: {
            width: '700px',
            height: '90px',
            padding: '15px 20px'
        },
        [theme.breakpoints.up('md')]: {
            width: '975px',
            height: '84px',
            padding: '15px 20px'
        },
        display: 'flex', flexDirection: 'row', alignItems: 'center',
    },
    "& .MuiBackdrop-root": {
        background: "transparent", backgroundColor: 'transparent',
        border: '0px solid green',
        margin: '0px !important',
    },
    '& .MuiDialogContent-root': {
    },
    '& .MuiDialogActions-root': {
    },
}));
export default function SelectedInfluncers(props) {
    const { open = true, setOpen = () => { },setSearchParams, handleAddInfluncerToList, setShowWishlistListingModal, setDeselectConfirmationModal, setCreateWishlistModalOpen, dispatch,selectedWishlist } = props;
    const handleClose = () => {
        setOpen(false)
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const handleStateWishlistDropdown = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const { selectedInfluencers } = useSelector(state => state.dashboardSlice)
    const { wishlistList } = useSelector(state => state.wishlistSlice);
    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title ccc"
                open={open}
            >
                <Stack direction="row" justifyContent={{ xs: "space-evenly", sm: "center" }} alignItems="center" sx={{ background: 'transparent', width: '100%' }}>
                    <Stack direction="row"
                        gap={{ xs: 1, sm: 2, md: 3 }}
                        alignItems="center">
                        <Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '20px' }, fontWeight: '600', color: 'white' }}>
                            {selectedInfluencers?.length} Influncers Selected
                        </Typography>
                        {selectedWishlist?.id ?
                            <Tooltip title={capitalizeWords(selectedWishlist?.name || '')}><Button onClick={()=>handleAddInfluncerToList(null)} sx={{ "&:hover": { background: 'white', color: 'var(--color-blue)' }, fontWeight: '600', width: { xs: '140px', sm: '160px', md: '220px' }, height: '44px', padding: { xs: '2px', sm: '6px 6px', md: '12px 24px' }, borderRadius: '8px', background: 'white', color: 'var(--color-blue)' }}><img src={wishlistAddIcon} style={{ width: '20px', height: '20px' }} alt="" />&nbsp;<Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' }, fontWeight: '500', color: 'var(--color-blue)' }}>Add to {capitalizeWords(selectedWishlist?.name || "Selected")?.substring(0, 10)}</Typography></Button></Tooltip> :
                            <><Button onClick={handleStateWishlistDropdown} sx={{ "&:hover": { background: 'var(--color-blue)', color: 'white' }, width: { xs: '120px', sm: '160px', md: '160px' }, height: '44px', padding: { xs: '2px', sm: '6px 6px', md: '12px 24px' }, borderRadius: '8px', background: 'var(--color-blue)', color: 'white' }}><img src={plusIcon} style={{ width: '20px', height: '20px' }} alt="" />&nbsp;<Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' }, fontWeight: '500', color: 'white' }}>Add to List</Typography></Button>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={() => setAnchorEl(null)}
                                    sx={{
                                        '& .MuiMenu-list': {
                                            paddingTop: 0,
                                        }
                                    }}
                                    PaperProps={{
                                        sx: {
                                            mt: -0.7,
                                            borderRadius: '8px',
                                            backgroundColor: '#fff',
                                            width: '200px',
                                            maxWidth: '235px',
                                        }
                                    }}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                    transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                                    <MenuItem
                                        sx={{
                                            borderBottom: '1px solid #EEE', display: 'flex', justifyContent: 'space-between',
                                            alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                                        }}
                                        onClick={() => {
                                            setCreateWishlistModalOpen(true)
                                        }}
                                        defaultValue=""
                                    >
                                        <Stack direction="row" justifyContent="flex-start" gap={1} sx={{ px: 1 }} alignItems="center" ><img src={plusIcon} style={{ filter: 'invert(36%) sepia(98%) saturate(7476%) hue-rotate(201deg) brightness(101%) contrast(104%)', width: '20px', height: '20px' }} alt="plus icon" /> <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'var(--color-blue)' }}>Create new list</Typography></Stack>
                                    </MenuItem>
                                    <MenuItem
                                        disabled
                                        sx={{
                                            borderBottom: '0px solid #EEE', display: 'flex', justifyContent: 'space-between',
                                            alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                                        }}
                                        defaultValue=""
                                    >
                                        <Typography sx={{ flexGrow: 1, px: 1, fontSize: '16px', fontWeight: 500, color: '#2B2829' }}>You're lists</Typography>
                                    </MenuItem>
                                    {wishlistList?.slice(-2)?.reverse()?.map((item) => (
                                        <MenuItem
                                            sx={{
                                                borderBottom: '0px solid #EEE', display: 'flex', justifyContent: 'space-between',
                                                alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                                            }}
                                            onClick={() => {
setSearchParams({wishlistId:item.id})
                                            }}
                                            defaultValue=""
                                        >
                                            <Typography sx={{ flexGrow: 1, px: 1, fontSize: '16px', fontWeight: 500, color: '#2B2829', textTransform: 'capitalize' }}>{item?.name}</Typography>
                                        </MenuItem>
                                    ))}
                                    <MenuItem
                                        sx={{
                                            borderBottom: '0px solid #EEE', display: 'flex', justifyContent: 'space-between',
                                            alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                                        }}
                                        onClick={() => {
                                            setShowWishlistListingModal(true)
                                        }}
                                        defaultValue=""
                                    >
                                        <Typography sx={{ px: 1, fontSize: '16px', fontWeight: 500, color: '#7209B7' }}>View All list</Typography>
                                    </MenuItem>
                                </Menu>
                            </>}
                        <Button onClick={() => setDeselectConfirmationModal(true)} sx={{ "&:hover": { background: 'white', color: 'var(--red)' }, width: { xs: '130px', sm: '150px', md: '200px' }, height: '44px', padding: { xs: '2px', sm: '6px', md: '12px 24px' }, borderRadius: '8px', background: 'white', }}><img src={Xred} style={{ width: '20px', height: '20px' }} alt="" />&nbsp;<Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' }, fontWeight: '500', color: 'var(--red)' }}>Deselect all</Typography></Button>
                    </Stack>
                </Stack>
            </BootstrapDialog>
        </>
    );
}
